// types
import { ConfigProps } from 'types/config';
// @ts-ignore
import config_ext from '../../config_ext.js';

export const JWT_API = {
    secret: 'SECRET-KEY',
    timeout: '1 days'
};

export const FIREBASE_API = {
    apiKey: 'AIzaSyBernKzdSojh_vWXBHt0aRhf5SC9VLChbM',
    authDomain: 'berry-material-react.firebaseapp.com',
    projectId: 'berry-material-react',
    storageBucket: 'berry-material-react.appspot.com',
    messagingSenderId: '901111229354',
    appId: '1:901111229354:web:a5ae5aa95486297d69d9d3',
    measurementId: 'G-MGJHSL8XW3'
};

export const AUTH0_API = {
    client_id: '7T4IlWis4DKHSbG8JAye4Ipk0rvXkH9V',
    domain: 'dev-w0-vxep3.us.auth0.com'
};

export const AWS_API = {
    poolId: 'us-east-1_e1MIPlqVo',
    appClientId: '37kc67qeln9n0mk04vhejhp8p1'
};
 // local / non-prod builds override the Cognito pool at build time
 export const AWS_API_BS = {
    poolId: config_ext.cognito?.pool_id || 'il-central-1_t0NzUbXbA',
    appClientId: config_ext.cognito?.client_id || '7j2ulcbmgi56jd62jeragslhjo',
};

/* export const  AWS_API_BS = {
  poolId:  'il-central-1_LKsend6UY', // e.g. "eu-west-1_xxxxxxxx"
  appClientId:  '3ccnjvagstlgnh543i5dur5i45',      // must be client without a secret!
}; */
export const  poolData = {
  UserPoolId:  AWS_API_BS.poolId, // e.g. "eu-west-1_xxxxxxxx"
  ClientId:  AWS_API_BS.appClientId,      // must be client without a secret!
};

// basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
// like '/berry-material-react/react/default'
export const BASE_PATH = '';

export const DASHBOARD_PATH = '/accounts/list';
// XXX colin: login + app pages still live on IIS www.bstage.io (api CORS only
// allows www), set to '' once land.bstage.io serves the app. app2.bstage.io
// (parallel linux hosts) serves the whole app itself
export let app_url = config_ext.is_prod
  && window.location.hostname != 'app2.bstage.io' ? 'https://www.bstage.io'
  : '';
export const google_ApiKey = 'AIzaSyBvBeoqALhoZrvR416NJK5cq8VWsNZdy3c';
export const maxFileUploadSize_MB = 5;
const config: ConfigProps = {
    gridPageSize: 10,
    fontFamily: `'Verdana', 'Arial', sans-serif`,
    borderRadius: 8,
    outlinedFilled: true,
    navType: 'light', // light, dark
    presetColor: 'theme_bs', // default, theme1, theme2, theme3, theme4, theme5, theme6
    locale: 'he', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
    rtlLayout: true,
    container: false,
    openDrawer: false,
    fetch_performance_report_delay: 500,
    imageSubmitFee: 0.5,
    videoSubmitFee: 1.3,
    setupFee: 300,
    version_num: '21.19',
    imageMaxSize_MB: 1.5,
    videoMaxSize_MB: 25,
    isDev:false,
    vat:18,
    incl_vat:1.18,
    add_ms_view: false,
    aws_comm:true,
};

export default config;
